import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthToken, setAuthTokenProvider } from '../lib/api';

/**
 * Bridges the Clerk session token into the API client so every request
 * carries `Authorization: Bearer <jwt>`. Mirrors the mobile app's token
 * wiring in apps/mobile/app/_layout.tsx (skipCache ensures a fresh JWT).
 */
export default function AuthSync() {
  const { isLoaded, isSignedIn, getToken } = useAuth();

  useEffect(() => {
    setAuthTokenProvider(async () => {
      try {
        return await getToken({ skipCache: true });
      } catch {
        return null;
      }
    });
    if (!isLoaded) return;
    if (isSignedIn) {
      getToken().then((token) => setAuthToken(token ?? null));
    } else {
      setAuthToken(null);
    }
    return () => {
      setAuthTokenProvider(null);
    };
  }, [isLoaded, isSignedIn, getToken]);

  return null;
}
